import mapboxgl from 'mapbox-gl';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.js';

export default async () => {
  const key =
    'pk.eyJ1Ijoic2xpY2VtZWRpYSIsImEiOiJja2U5OWs4OWUyNTE3MnpsZm12NnF6ajhsIn0.J1wG8Pd3XJFsMuiUPIIUuQ';

  async function geocodeAddress(address) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${key}&types=address`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.features && data.features[0]) {
        const coords = data.features[0].center; // [lng, lat]
        return coords;
      }
    } catch (error) {
      console.error('Geocoding failed:', error);
    }

    return null;
  }

  async function showMapWithMarker(container, address) {
    mapboxgl.accessToken = key;
    let addressLng = null;
    let addressLat = null;

    await geocodeAddress(address).then(([lng, lat]) => {
      addressLng = lng;
      addressLat = lat;
    });

    const marker = new mapboxgl.Marker({
      color: 'red',
      rotation: 45,
      scale: 1.5,
    }).setLngLat([addressLng, addressLat]);

    const map = new mapboxgl.Map({
      container, // container ID
      style: 'mapbox://styles/mapbox/streets-v12', // style URL
      center: [addressLng, addressLat], // starting position [lng, lat]
      zoom: 15, // starting zoom
    });

    const directions = new MapboxDirections({
      accessToken: key,
      unit: 'metric',
      profile: 'driving', // or 'walking', 'cycling'
      alternatives: true,
      geometries: 'geojson',
    });

    map.addControl(directions, 'top-right');

    directions.setDestination([addressLng, addressLat]);

    map.on('load', () => {
      marker.addTo(map);
    });

    return map;
  }

  const mapContainers = document.querySelectorAll('[component="map"]');

  mapContainers.forEach(async (mapContainer) => {
    const { street, zipCode, city, country } = mapContainer.dataset;

    await showMapWithMarker(mapContainer, `${street}, ${zipCode} ${city}, ${country}`);
  });
};
